const socialMediaLinks = {
  youtube: "https://www.youtube.com/@simplaystudio",
  tiktok:
    "https://www.tiktok.com/@fireworksplayofficial?is_from_webapp=1&sender_device=pc",
  discord: "https://discord.gg/4hTJcr8GUt",
};
export default socialMediaLinks;
